<template>
  <div class="p-auth p-auth--single">
    <section class="p-auth__panel">
      <div class="p-auth__form">
        <header class="p-auth__head p-auth__head--center">
          <img src="/favicon.png" alt="Pineapple" class="p-auth__icon" />
          <p class="p-auth__head-eyebrow">RESET PASSWORD</p>
          <h1 class="p-auth__head-title">비밀번호 재설정</h1>
          <p class="p-auth__head-sub">
            가입하신 이메일로 재설정 안내가 전송됩니다<br />
            <span class="p-auth__hint">최대 60초 내 도착</span>
          </p>
        </header>

        <form class="p-auth__veeform" @submit.prevent>
          <div class="p-field">
            <label class="p-field__label" for="reset-email">
              <i class="material-icons-round p-field__label-icon">mail</i>
              이메일 <span class="p-field__req">*</span>
            </label>
            <input id="reset-email" type="email" placeholder="name@example.com" class="p-input" />
          </div>

          <ABtn type="submit" kind="primary" block icon="send" class="p-auth__submit">재설정 메일 보내기</ABtn>

          <p class="p-auth__alt">
            <router-link :to="{ name: 'Signin Cover' }">로그인으로 돌아가기</router-link>
          </p>
        </form>

        <p class="p-auth__footer">© {{ new Date().getFullYear() }} Pineapple Academy</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ABtn from "@/components/Pineapple/ABtn.vue";

export default {
  name: "ResetCover",
  components: { ABtn },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.p-auth {
  min-height: 100vh;
  background: $p-bg;
  font-family: $p-font-body;
  display: grid;
  place-items: center;
  padding: 24px;
}

.p-auth__panel {
  background: $p-panel;
  border: 1px solid $p-line;
  border-radius: $p-radius-lg;
  box-shadow: 0 20px 60px rgba(31, 27, 20, 0.10);
  width: 100%;
  max-width: 420px;
  padding: 36px;
}

.p-auth__form { display: flex; flex-direction: column; gap: 24px; }

.p-auth__head {
  display: flex;
  flex-direction: column;
  gap: 4px;
  &--center { text-align: center; align-items: center; }
}

.p-auth__icon { width: 56px; height: 56px; margin-bottom: 12px; }

.p-auth__head-eyebrow { font-size: 11px; font-weight: 800; letter-spacing: 0.16em; color: $p-point-deep; margin: 0; }
.p-auth__head-title { margin: 0; font-size: 24px; font-weight: 800; color: $p-ink; }
.p-auth__head-sub { margin: 4px 0 0; font-size: 13px; color: $p-ink-mid; line-height: 1.6; }
.p-auth__hint { font-size: 11px; color: $p-ink-soft; }

.p-auth__veeform { display: flex; flex-direction: column; gap: 4px; }

.p-auth__submit { margin-top: 8px; height: 42px !important; }

.p-auth__alt {
  text-align: center; font-size: 13px; margin: 8px 0 0;
  a { color: $p-point-deep; font-weight: 700; text-decoration: none;
    &:hover { text-decoration: underline; }
  }
}

.p-auth__footer { margin: 16px 0 0; text-align: center; font-size: 11px; color: $p-ink-soft; }
</style>
